import * as ReselectModule from "reselect";
import { IDefaultDocumentFolderListState } from ".";
import { IApplicationState } from "..";

export const selectDefaultDocumentFolderList: ReselectModule.Selector<
  IApplicationState,
  IDefaultDocumentFolderListState
> = (state) => state.defaultDocumentFolderList;
